import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=35644434&scoped=true"
import script from "./Storage.vue?vue&type=script&lang=ts"
export * from "./Storage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35644434",
  null
  
)

export default component.exports